module.exports = __webpack_public_path__ + "img/13_l_uk.690c93d4.svg";